/**
 * loadMoreButton
 * @param {string} url - next page
 * @returns [{object}] products
 */

const loadProducts = (url) =>
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      return new DOMParser().parseFromString(text, 'text/html');
    })
    .catch((error) => {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }
      this.close();
      throw error;
    });

export default loadProducts;
